export default {
  title: 'Tallenna yhteys- ja maksutiedot',
  form: {
    remember_me: {
      label: 'Luo tili nopeampaa kassalle siirtymistä varten tulevissa tilauksissa.',
    },
  },
};
